/* eslint-disable no-console, react/prop-types, react/jsx-filename-extension, react/function-component-definition */
import React, { useState } from "react";
import { Container, Tabs, Tab } from "react-bootstrap";
import { connect } from "react-redux";
import { SuperAdminAction } from "../../Actions";
import ReportData from "./AdvancedRevenueReportData";

const AdvancedRevenue = ({ mainBody, PropertyId, getAdvancedRevenuePDF }) => {
  const [activeTab, setActiveTab] = useState("report");

  const handleTabSelect = (k) => setActiveTab(k);

  return (
    <Container
      fluid
      style={{
        overflowY: "visible",
        maxHeight: "unset",
        paddingBottom: "80px", // ensure space for footer
      }}
    >
      <Tabs
        activeKey={activeTab}
        id="advanced-revenue-tabs"
        onSelect={handleTabSelect}
        transition={false}
        className="mb-0"
        style={{
          overflowY: "visible",
        }}
      >
        <Tab
          eventKey="report"
          title="Advanced Revenue Report"
          className="m-0"
          style={{
            overflowY: "visible",
          }}
        >
          <ReportData PropertyId={PropertyId} mainBody={mainBody} getAdvancedRevenuePDF={getAdvancedRevenuePDF} />
        </Tab>
      </Tabs>
    </Container>
  );
};

const mapStateToProps = ({ UserProfileDetails, Logindetails }) => {
  const { property_id: PropertyId } = UserProfileDetails;
  const { backgroundColor } = Logindetails;
  const { MainBackground: mainBody } = backgroundColor || {};
  return { PropertyId, mainBody };
};

const mapDispatchToProps = {
  getAdvancedRevenuePDF: SuperAdminAction.getAdvancedRevenuePDF,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedRevenue);
